import Crud from '../views/TipoDesfecho/Crud'
import Entity from '../views/TipoDesfecho/Add'

let routes = {
    path: '/tipo_desfechos',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/tipo_desfechos/add',
            name: 'NewTipoDesfecho',
            component: Entity
        },
        {
            path: '/tipo_desfechos/edit/:id?',
            name: 'EditTipoDesfecho',
            component: Entity
        },
        {
            path: '/tipo_desfechos',
            name: 'list-tipo_desfechos',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Tipo Desfechos',
                breadcrumb: [
                    {
                        text: 'Tipo Desfecho',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
